import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { segmentAutocompleteGet } from "../../../../services/procurement/procurementAPIs";
import alertDispatcher from "../../../../utils/alertsUtils";
import { ACCOUNT_INPUT_PLACEHOLDER, ACCOUNT_LABEL } from "../labels";
import SearchAsYouType from "../searchAsYouType";

const AccountSearchAsYouType = ({
    disabled,
    selectedValue,
    setSelectedValue,
}) => {
    const dispatch = useDispatch();

    const autocompleteGet = (searchTerm, setOptions, setIsLoading) => {
        let newOptions = [];

        // If an input is selected, set it as the option
        if (selectedValue) {
            newOptions = [selectedValue];
        }

        setIsLoading(true);

        segmentAutocompleteGet(3, searchTerm)
            .then((results) => {
                if (results) {
                    newOptions = [...newOptions, ...results];
                }
                setOptions(newOptions);
            })
            .catch((error) => {
                alertDispatcher(
                    "accountAutocompleteGet",
                    error?.response?.status,
                    dispatch
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <SearchAsYouType
            selectedValue={selectedValue}
            onSelectValue={setSelectedValue}
            isDisabled={disabled}
            autocompleteGet={autocompleteGet}
            searchPrompt={ACCOUNT_INPUT_PLACEHOLDER}
            label={ACCOUNT_LABEL}
            optionKeyMapping={{
                id: "SEGMENT3_ID",
                label: "SEGMENT3_NAME",
            }}
        />
    );
};

AccountSearchAsYouType.propTypes = {
    disabled: PropTypes.bool,
    selectedValue: PropTypes.object,
    setSelectedValue: PropTypes.func.isRequired,
};

export default AccountSearchAsYouType;
